import { StackStatus } from "../../../services/backend_gateway/__generated__/backend_gateway-types";
import { VpcComponent } from "./component";

export const VpcContainer = (props: {
  deploymentId: string;
  navigateToHelp: (stepId: string) => void;
  vpcStackStatus: StackStatus | null;
}) => {
  const { deploymentId, vpcStackStatus } = props;

  return (
    <VpcComponent
      loading={false}
      deploymentId={deploymentId}
      vpcStackParamsJson={vpcStackStatus?.parametersJSON || null}
      vpcStackStatus={vpcStackStatus?.status || null}
    />
  );
};
